import _extends from "@babel/runtime/helpers/extends";

/**
  * 将数据序列化为树形结构
  * @param  {Array} list 树结构数据
  * @param {String} id 用于通用遍历树，每种树结构的id取名可能不一样
  * @param {Srting} name 用于通用遍历树，每种树结构的pid取名可能不一样
  * @param {Srting} name 用于通用遍历树，每种树结构的name取名可能不一样
  * @return {[type]}      [description]
  */
function serializeTree(list, options) {
  if (list === void 0) {
    list = [];
  }

  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$id = _options.id,
      id = _options$id === void 0 ? 'funcId' : _options$id,
      _options$parentId = _options.parentId,
      parentId = _options$parentId === void 0 ? 'funcParent' : _options$parentId,
      _options$name = _options.name,
      name = _options$name === void 0 ? 'funcName' : _options$name;
  var trees = []; // 树状结构

  var maps = {}; // 节点id与节点对象映射

  list = list.map(function (item) {
    return _extends({}, item);
  });
  var pid; // 父节点id
  // 遍历添加映射

  list.forEach(function (item) {
    // 设置转换为通用结构
    item.id = item[id];
    item.name = item[name];
    item.parentId = item[parentId];
    item.label = item.name;
    item.title = item.name;
    item.key = item.id;
    item.value = item.id; // 映射结构

    maps[item.id] = item;
  }); // 遍历组装树

  list.forEach(function (item, i) {
    // 获取父id
    pid = item.parentId; // 判断当前pid是否存在对应的节点，即当前项父项是否存在
    // 并且当前id不pid

    if (maps[pid] && item[id] !== pid) {
      // 设置父项子项
      if (!maps[pid].children) maps[pid].children = [];
      maps[pid].children.push(item);
    } else {
      trees.push(item);
    }
  });
  return trees;
}

export default serializeTree;